var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useCallback, useEffect, useRef, } from 'react';
import { useNavigate } from './hooks.js';
import { useIsRouteTransitioning } from './TransitionIndicator.js';
export const Link = forwardRef(function Link(_a, ref) {
    var { to: rawTo, onClick, external: forceExternal, newTab, replace, skipTransition = false, state, preserveQuery } = _a, rest = __rest(_a, ["to", "onClick", "external", "newTab", "replace", "skipTransition", "state", "preserveQuery"]);
    const to = resolve(rawTo);
    const external = forceExternal !== null && forceExternal !== void 0 ? forceExternal : isExternal(to);
    const transitioning = useIsRouteTransitioning();
    const preserveScroll = rawTo.startsWith('?');
    const wasClickedRef = useRef(false);
    // preloading and router stuff isn't useful for external or newTab
    const notRouterCompatible = external || newTab;
    useEffect(() => {
        if (notRouterCompatible)
            return;
        const cleanups = [];
        return () => {
            // skip cleanup if the link was clicked
            if (wasClickedRef.current) {
                wasClickedRef.current = false;
                return;
            }
            for (const cleanup of cleanups) {
                cleanup();
            }
        };
    }, [notRouterCompatible]);
    const navigate = useNavigate();
    const handleClick = useCallback(function handleClick(event) {
        event.preventDefault();
        wasClickedRef.current = true;
        let destination = to;
        if (preserveQuery) {
            const currentQuery = new URLSearchParams(window.location.search);
            const destinationQuery = new URLSearchParams(to.split('?')[1]);
            currentQuery.forEach((value, key) => {
                if (!destinationQuery.has(key)) {
                    destinationQuery.set(key, value);
                }
            });
            destination = `${to.split('?')[0]}?${destinationQuery.toString()}`;
        }
        navigate(destination, {
            replace,
            skipTransition,
            state,
            preserveScroll,
        });
        onClick === null || onClick === void 0 ? void 0 : onClick(event);
    }, [
        onClick,
        replace,
        state,
        preserveQuery,
        preserveScroll,
        to,
        navigate,
        skipTransition,
    ]);
    const pathAtRenderTime = typeof window !== 'undefined' ? window.location.pathname : '';
    const newTabProps = newTab
        ? {
            target: '_blank',
            rel: 'noopener noreferrer',
        }
        : {};
    return (_jsx("a", Object.assign({ ref: ref, href: to, onClick: notRouterCompatible ? onClick : handleClick, "data-transitioning": pathAtRenderTime === to && transitioning, "data-active-exact": pathAtRenderTime === to }, newTabProps, rest)));
});
function isExternal(url = '') {
    return /^(\w+):\/\//.test(url);
}
function resolve(path = '') {
    if (path.startsWith('.')) {
        return new URL(path, window.location.href).pathname;
    }
    if (path.startsWith('?')) {
        return window.location.pathname + path;
    }
    return path;
}
//# sourceMappingURL=Link.js.map